<template>
    <div>
        <div class="recordBox" v-loading="loading">
                <div class="recordItem" v-for="(item,index) in journalList" :key="index">
                    <div class="record">
                        <label>修改时间：</label>
                        {{item.created_at}}
                    </div>
                    <div>
                        <label>修改者：</label>
                        {{item.op_user_name}}
                    </div>
                    <div>
                        <label>修改者角色：</label>
                        {{item.op_user_role}}
                    </div>
                    <div class="record" style="width:100%;">
                        <label>修改内容：</label>
                        <el-tooltip effect="dark" placement="top-start">
                            <div slot="content" >{{item.content}}</div>
                            <span>{{item.content}}</span>
                        </el-tooltip>
                    </div>
                    <div class="record" style="width:100%;">
                        <label>修改原因：</label>
                        <el-tooltip effect="dark" placement="top-start">
                            <div slot="content" style="max-width:400px">{{item.op_reason}}</div>
                            <span>{{item.op_reason}}</span>
                        </el-tooltip>
                    </div>
                    <br/>
                    <br/>
                    <div>
                        <label>媒介审核：</label>
                        {{item.verify_user_name}}
                    </div>
                    <div>
                        <label>审核状态：</label>
                        {{item.mj_status==1?'审核通过':item.mj_status==2?'审核未通过':'未审核'}}
                    </div>
                    <div style="width:30%">
                        <label>审核时间：</label>
                        {{item.verify_at}}
                    </div>
                    <div class="record" style="width:100%;">
                        <label>审核意见：</label>
                        <el-tooltip effect="dark" placement="top-start">
                            <div slot="content" style="max-width:400px">{{item.verify_note}}</div>
                            <span>{{item.verify_note}}</span>
                        </el-tooltip>
                    </div>
                    <br/>
                    <br/>
                    <div>
                        <label>财务审核：</label>
                        {{item.final_verify_user_name}}
                    </div>
                    <div>
                        <label>审核状态：</label>
                        {{item.cw_status==1?'审核通过':item.cw_status==2?'审核未通过':'未审核'}}
                    </div>
                    <div style="width:30%">
                        <label>审核时间：</label>
                        {{item.final_verify_at}}
                    </div>
                    <div class="record" style="width:100%;">
                        <label>审核意见：</label>
                        <el-tooltip effect="dark" placement="top-start">
                            <div slot="content" style="max-width:400px">{{item.final_verify_note}}</div>
                            <span>{{item.final_verify_note}}</span>
                        </el-tooltip>
                    </div>
                </div>
                <p v-if="journalList.length==0&&!loading" style="text-align: center;padding: 40px;">暂无记录</p>
        </div>
        <div style="text-align: center;margin-top:20px">
            <el-button type="primary" @click="closeToast" size='small'>关 闭</el-button>
        </div>
    </div>
</template>
<script>
export default {
    props:['order_id','record_id'],
    data(){
        return{
            loading:true,
            journalList:[],
        }
    },
    created(){
        this.getEditInfo()
    },
    methods:{
        closeToast(){
            this.$emit('cancelToast')
        },
        getEditInfo(){
            this.loading = true;
            this.$axios.get(this.URL.BASEURL + this.URL.getOrderVeifyRecords,{
                params:{
                    order_id: this.order_id,
                    id: this.record_id?this.record_id:''
                }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.journalList = res.rst.order;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.recordBox{
    min-height: 300px;
    height: calc(100vh - 300px);
    overflow-y:auto ;
    border-top: 1px solid #E6E6EF;
    border-bottom: 1px solid #E6E6EF;
    margin-top: -20px;
}
.recordItem{
    border-top: 1px solid #E6E6EF;
    padding: 20px 0;
    &:first-of-type{
        border-top: none;
    }
    div{
        width: 24%;
        display: inline-block;
        line-height: 20px;
        color: #5E5F6B;
        font-size: 12px;
        margin:5px 0;
        vertical-align: middle;
        label{
            color: #202652;
        }
    }
    .record{
        width: 45%;
        // overflow: hidden;
        // text-overflow:ellipsis; 
        // white-space: nowrap;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Order/orderJournal.vue